/** PCG facturation — liste courte, pas le plan entier. */

export type PcgAccount = { code: string; label: string };

export const PCG_SALES: PcgAccount[] = [
  { code: "706", label: "Prestations de services" },
  { code: "707", label: "Ventes de marchandises" },
  { code: "708", label: "Produits des activités annexes" },
  { code: "701", label: "Ventes de produits finis" },
  { code: "704", label: "Travaux" },
  { code: "705", label: "Études" },
];

export const PCG_CUSTOMERS: PcgAccount[] = [
  { code: "411", label: "Clients" },
  { code: "4111", label: "Clients — ventes de biens ou prestations" },
  { code: "416", label: "Clients douteux ou litigieux" },
];

export const PCG_SALES_DEFAULT = "706";
export const PCG_CUSTOMER_DEFAULT = "411";

function digitsOnly(raw: string, max: number): string {
  return raw.replace(/\D/g, "").slice(0, max);
}

export function pcgFull(code: string, sub: string): string {
  const c = digitsOnly(code, 8);
  const s = digitsOnly(sub, 8);
  if (!c) return s;
  if (!s) return c;
  return s.startsWith(c) ? s : c + s;
}
